import { MapMarkerMultipleOutlineIcon } from './MapMarkerMultipleOutlineIcon';

/**
 * author: Austin Andrews
 * id 360866E5-D407-4E54-9470-7ECF6759F941
 * name map-marker-multiple-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-multiple-outline.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationMultipleOutlineIcon = MapMarkerMultipleOutlineIcon;
export default LocationMultipleOutlineIcon